// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2m_hI","noInteraction":"EventWrapper_noInteraction__EpUCq","pointerPassthrough":"EventWrapper_pointerPassthrough__3UCUq"};